// services/orderApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../../config';

export const orderApi = createApi({
	reducerPath: 'orderApi',
	baseQuery: fetchBaseQuery({
		baseUrl: API_BASE_URL + "/api/order",
		prepareHeaders: (headers, { getState }) => {
			const token = localStorage.getItem("accessToken");
			if (token) {
				headers.set('Authorization', `Bearer ${token}`);
			}
			return headers;
		},
	}),
	tagTypes: ["order"],
	endpoints: (builder) => ({
		getOrders: builder.query({
			query: (status) => `/orderList?status=${status}`,
			providesTags: ["order"],
		}),
		createOrEditOrder: builder.mutation({
			query: (formData) => ({
				url: "/order-client-craete",
				method: "POST",
				body: formData,
			}),
			invalidatesTags: ["order"],
		}),
		declareOrder: builder.mutation({
			query: (formData) => ({
				url: "/createEditOrder",
				method: "POST",
				body: formData,
			}),
			invalidatesTags: ["order"],
		}),
		issueOrder: builder.mutation({
			query: ({ orderId }) => ({
				url: `/api/app/order/issue/${orderId}`,
				method: "POST",
			}),
			invalidatesTags: ["order"],
		}),
		changePickupOrder: builder.mutation({
			query: (body) => ({
				url: `/change-pickup-order`,
				method: "POST",
				body: body
			}),
			invalidatesTags: ["order"],
		}),
		setDeliveryAddress: builder.mutation({
			query: (body) => ({
				url: `/set-delivery-address`,
				method: "POST",
				body: body
			}),
			invalidatesTags: ["order"],
		}),
		orderPay: builder.mutation({
			query: (body) => ({
				url: `/client-order-payment`,
				method: "POST",
				body: body
			}),
			invalidatesTags: ["order"],
		}),
		deleteOrder: builder.mutation({
			query: (body) => ({
				url: `/delete-order`,
				method: "DELETE",
				params: body
			}),
			invalidatesTags: ["order"],
		}),
		updateUserPackages: builder.mutation({
			query: (body) => ({
				url: `/rule/package-order`,
				method: "POST",
				body: body
			}),
			invalidatesTags: ["order"],
		}),

		getUserPackages: builder.query({
			query: () => ({
				url: `/rule/package-order`,
			}),
			invalidatesTags: ["order"],
		}),

		generatePickupQR: builder.mutation({
			query: () => ({
				url: `/generate-pvz`,
				method: "POST",
			}),
			invalidatesTags: ["order"],
		}),

		issueSmartOrder: builder.mutation({
			query: () => ({
				url: `/smart/scan-qr`,
				method: "POST",
			}),
			invalidatesTags: ["order"],
		}),

		getActivePickupSession: builder.query({
			query: () => ({
				url: `/get/issue-token`,
			}),
			providesTags: ["order"],
		}),
	}),
});

export const { useGetOrdersQuery,
	useCreateOrEditOrderMutation,
	useIssueOrderMutation,
	useDeclareOrderMutation,
	useChangePickupOrderMutation,
	useSetDeliveryAddressMutation,
	useOrderPayMutation,
	useDeleteOrderMutation,
	useUpdateUserPackagesMutation,
	useGetUserPackagesQuery,
	useGeneratePickupQRMutation,
	useIssueSmartOrderMutation,
	useGetActivePickupSessionQuery
} = orderApi;
